import { render, staticRenderFns } from "./ServicePage1.vue?vue&type=template&id=90317a38"
import script from "./ServicePage1.vue?vue&type=script&lang=js"
export * from "./ServicePage1.vue?vue&type=script&lang=js"
import style0 from "./ServicePage1.vue?vue&type=style&index=0&id=90317a38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports